import React from "react";
import OperationButton from "./operation-button.jsx";
import { onXESCheck } from "../../../reducers/project-state.js";

// import { toggleLoading as toggleCheckLoading } from './operation-button.jsx'

let toggleCheckLoading
let toggleCheckDisabled
class CheckButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      disabled: false
    }
    toggleCheckLoading = (loading) => {
      this.setState({
        loading
      })
    }
    toggleCheckDisabled = (disabled) => {
      this.setState({
        disabled
      })
    }
  }

  render(){
    return (
      <OperationButton getAction={onXESCheck}
        loading={this.state.loading}
        disabled={this.state.disabled}
      >
        检查
      </OperationButton>    
    )
  }


}

export default () => (
  <CheckButton></CheckButton>
)



// export default () => (
//   <OperationButton getAction={onXESCheck}>检查</OperationButton>
// )

export {
  toggleCheckLoading,
  toggleCheckDisabled
}